__turbopack_context__.v({
  "GC": "styles-module-scss-module__iTNYFG__GC",
  "SC": "styles-module-scss-module__iTNYFG__SC",
  "button": "styles-module-scss-module__iTNYFG__button",
  "caption": "styles-module-scss-module__iTNYFG__caption",
  "captionDarkMode": "styles-module-scss-module__iTNYFG__captionDarkMode",
  "categoryLink": "styles-module-scss-module__iTNYFG__categoryLink",
  "customUnderline": "styles-module-scss-module__iTNYFG__customUnderline",
  "darkMode": "styles-module-scss-module__iTNYFG__darkMode",
  "defaultColor": "styles-module-scss-module__iTNYFG__defaultColor",
  "description": "styles-module-scss-module__iTNYFG__description",
  "fullWidth": "styles-module-scss-module__iTNYFG__fullWidth",
  "gameInfoCol": "styles-module-scss-module__iTNYFG__gameInfoCol",
  "goldColor": "styles-module-scss-module__iTNYFG__goldColor",
  "oddGrid": "styles-module-scss-module__iTNYFG__oddGrid",
  "prizeDescription": "styles-module-scss-module__iTNYFG__prizeDescription",
  "providerContainer": "styles-module-scss-module__iTNYFG__providerContainer",
  "providerIcon": "styles-module-scss-module__iTNYFG__providerIcon",
  "root": "styles-module-scss-module__iTNYFG__root",
  "smallGrid": "styles-module-scss-module__iTNYFG__smallGrid",
  "sweepColor": "styles-module-scss-module__iTNYFG__sweepColor",
});
